import React from 'react';
import cn from 'classnames';

const PopOver = ({ children, title, direction = 'left', ...rest }) => {
  return (
    <div className={cn('pop_up_container', { [direction]: direction })} {...rest}>
      {children}
      <div className="pop_up_body">
        {title}
        <div className="pop_up_arrow" />
      </div>
    </div>
  );
};

export default PopOver;



// WEBPACK FOOTER //
// ./app/javascript/common/components/PopOver/PopOver.js